import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledNotesIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5859 1.5C14.9837 1.50004 15.3652 1.65818 15.6465 1.93945L19.0605 5.35352C19.3418 5.63479 19.5 6.01629 19.5 6.41406V20C19.5 21.3807 18.3807 22.5 17 22.5H7C5.61929 22.5 4.5 21.3807 4.5 20V4C4.5 2.61929 5.61929 1.5 7 1.5H14.5859Z",
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 9.5H17",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12H17",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 14.5H13",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 5.5L15.5 2.5V5.5H18.5Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2V5C15 5.55228 15.4477 6 16 6H19",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledNotesIcon);
const Memo = memo(ForwardRef);
export default Memo;
